"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptCust = acceptCust;
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.editStoreInto = editStoreInto;
exports.get = get;
exports.rejectCust = rejectCust;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/storeInto',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/storeInto/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/storeInto',
    method: 'put',
    data: data
  });
}

function editStoreInto(data) {
  return (0, _request.default)({
    url: 'api/storeInto/edit',
    method: 'put',
    data: data
  });
}

function get(data) {
  return (0, _request.default)({
    url: 'api/storeInto/get',
    method: 'get',
    data: data
  });
}

function rejectCust(custId) {
  return (0, _request.default)({
    url: 'api/storeInto/rejectCust',
    method: 'put',
    data: custId
  });
}

function acceptCust(custId) {
  return (0, _request.default)({
    url: 'api/storeInto/acceptCust',
    method: 'put',
    data: custId
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  get: get,
  acceptCust: acceptCust,
  rejectCust: rejectCust
};
exports.default = _default;